import { Component, Object3D } from '@wonderlandengine/api';
import { property } from '@wonderlandengine/api/decorators.js';
import { TriggerTarget } from '../interactions/triggerTarget.js';
import { TextsManager } from '../core/texts-manager.js';
import {
    Coroutine,
    CoroutineManager,
    waitForSeconds,
    wlUtils,
} from '@sorskoot/wonderland-components';
import { GlobalEvents } from '../core/global-events.js';
import { Locomotion } from '../player/locomotion.js';

export class GameComplete extends Component {
    static TypeName = 'game-complete';
    private _triggerTarget?: TriggerTarget | null;

    @property.object({ required: true })
    theEndObject!: Object3D;
    @property.object({ required: true })
    locomotion!: Object3D;

    private _coroutineManager = new CoroutineManager();

    start(): void {
        this._triggerTarget = this.object.getComponent(TriggerTarget)!;
    }

    onActivate(): void {
        this._triggerTarget?.onExecute.add(this._onExecute);
    }

    onDeactivate(): void {
        this._triggerTarget?.onExecute.remove(this._onExecute);
    }

    update(dt: number) {
        this._coroutineManager.update(dt);
    }

    private _onExecute = () => {
        this._coroutineManager.addCoroutine(new Coroutine(this._finalSteps()));
    };

    private *_finalSteps() {
        yield* waitForSeconds(5);
        const pos = this.theEndObject.getPositionWorld();
        GlobalEvents.instance.teleportRequested.dispatch(pos);
        yield;
        this.locomotion.getComponent(Locomotion)?.destroy();
    }
}
